import styled from "styled-components";
import UpArrow from "../../../assets/AssetArrow.png";
import {
  Container,
  CardContainer,
  CMdExpandMore,
  CardTitle,
  MedicalCard,
  MedicalSearch,
  MedicalTab,
  Table,
} from "../../../style/Prescription";
import PmsDispensed from "../../../Pages/Pmc/Dispensed/Dispensed";
import PmsDispensedBilling from "./Billing/Billing";
import { Button } from "../../../style/Button";
import { useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
const Paper = styled.div`
  width: 100%;
  min-height: 45px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #c5c5c5;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 500;
`;

const Dispensed = () => {
  const history = useHistory()
  const backButtonHandler = () => {
    // history.pushState("partner")
    history.push("/Pmc/dashboard")
  }
  return (
    <>
      <Container>
        <Grid container>
          <Grid item md={4} lg={3} xs={12}>
            <div className="paddingRight-30">
              <Paper
                style={{
                  color: "#4678ED",
                  fontWeight: 600,
                  fontSize: "17px",
                  fontFamily:
                    "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
                  maxWidth: "100%",
                  width: "100%",
                  padding: "25px 25px",
                }}
              >
                New Medication
                <img
                  src={UpArrow}
                  style={{
                    marginLeft: "auto",
                    marginTop: "0px",
                    width: "20px",
                  }}
                />
              </Paper>
              <Paper
                style={{
                  color: "#606060",
                  fontSize: "17px",
                  fontWeight: 600,
                  fontFamily:
                    "Montserrat SemiBold, 'Open Sans', Helvetica, Arial, sans-serif",
                  maxWidth: "100%",
                  width: "100%",
                  padding: "25px 25px",
                }}
              >
                Medication history
                <img
                  src={UpArrow}
                  style={{
                    marginLeft: "auto",
                    marginTop: "0px",
                    width: "20px",
                    transform: "rotate(180deg)",
                  }}
                />
              </Paper>
            </div>
          </Grid>
          <Grid item md={8} lg={9} xs={12}>
            <PmsDispensedBilling />
          </Grid>
        </Grid>


      </Container>
      <div style={{ textAlign: "right" }}>
        <Button
          className="button4"
          height="fit-content"
          borderRadius="20px"
          onClick={backButtonHandler}
          style={{
            padding: "6px 37px",
            marginTop: 0,
            fontSize: "18px",
            marginLeft: "18px",
            marginTop: "15px",
            backgroundImage: "none",
            backgroundColor: "#D0D2D3",
            color: "#606060",
            fontWeight: 600,
            fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
            textAlign: "center",
            float: "right",
          }}
        >
          Back
        </Button>
      </div>
    </>
  );
};

export default Dispensed;
